import {
  GET_BILLING_DETAILS,
  GET_BILLING_DETAILS_SUCCESS,
  RESEND_BILLING_DETAIL_EMAIL,
  RESEND_BILLING_DETAIL_EMAIL_SUCCESS,
  RESEND_BILLING_DETAIL_EMAIL_FAILURE,
} from '../constants/ActionsTypes'

export const getBillingDetails = (params) => {
  return {
    type: GET_BILLING_DETAILS,
    payload: params,
  }
}

export const getBillingDetailsSuccess = (data) => {
  return {
    type: GET_BILLING_DETAILS_SUCCESS,
    payload: data,
  }
}

export const resendBillingDetailEmail = (id) => {
  return {
    type: RESEND_BILLING_DETAIL_EMAIL,
    payload: id,
  }
}

export const resendBillingDetailEmailSuccess = () => {
  return {
    type: RESEND_BILLING_DETAIL_EMAIL_SUCCESS,
  }
}

export const resendBillingDetailEmailFailure = (error) => {
  return {
    type: RESEND_BILLING_DETAIL_EMAIL_FAILURE,
    payload: error,
  }
}
